"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recipeDescriptiveNames = exports.recipeShortNames = exports.recipeByDescriptiveName = exports.recipeByShortName = exports.recipeNames = exports.allRecipes = void 0;
var lodash_1 = require("lodash");
var react_1 = require("./react");
var none = {
    descriptiveName: 'No recipe',
    shortName: 'none',
    configUpdate: lodash_1.identity,
    extraNpmDependencies: [],
    extraNpmDevDependencies: [],
    postConfiguration: function (cwd) { }
};
exports.allRecipes = [none, react_1.reactjs, react_1.reactts];
exports.recipeNames = lodash_1.map(exports.allRecipes, function (r) { return [r.shortName, r.descriptiveName]; });
var recipeByShortName = function (name) {
    return lodash_1.find(exports.allRecipes, function (r) { return r.shortName === name; });
};
exports.recipeByShortName = recipeByShortName;
var recipeByDescriptiveName = function (name) {
    return lodash_1.find(exports.allRecipes, function (r) { return r.descriptiveName === name; });
};
exports.recipeByDescriptiveName = recipeByDescriptiveName;
exports.recipeShortNames = lodash_1.map(exports.allRecipes, function (r) { return r.shortName; });
exports.recipeDescriptiveNames = lodash_1.map(exports.allRecipes, function (r) { return r.descriptiveName; });
